import { render, staticRenderFns } from "./SellerReclaimRequests.vue?vue&type=template&id=795ea7b7&scoped=true&"
import script from "./SellerReclaimRequests.vue?vue&type=script&lang=js&"
export * from "./SellerReclaimRequests.vue?vue&type=script&lang=js&"
import style0 from "./SellerReclaimRequests.vue?vue&type=style&index=0&id=795ea7b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795ea7b7",
  null
  
)

export default component.exports